
function printlayer(layer) {
    var ganerator = window.open(",'name',");
    var layertext = document.getElementById(layer);
    ganerator.document.write(layertext.innerHTML.replace("Print Me"));
    ganerator.document.write('<html><head><title>Print it!</title><link rel="stylesheet" type="text/css" href="https://shop.hooshmandsazeh.com/styles.8eec88b04286adab6f3f.css"></head>' + layertext.innerHTML.replace("Print Me") + '<body>');

    //ganerator.document.close();
    //ganerator.print();
    //ganerator.close();
}

function printlayer2(el) {
    var restorepage = document.body.innerHTML;
    var printcontent = document.getElementById(el).innerHTML;
    document.body.innerHTML = printcontent;
    window.print();
    //document.body.innerHTML = restorepage;
}


function adjustHeight(el) {
    el.style.height = (el.scrollHeight > el.clientHeight) ? (el.scrollHeight) + "px" : "60px";
}


